export const ReportExportType = 2 //1- FOR XLSX 2- FOR PDF